import dayjs from './dayjs';

const MEXICO_CITY = 'America/Mexico_City';
const HAS_TZ_OFFSET = /(Z|[+-]\d{2}:?\d{2})$/;

// dayjs.tz.setDefault() only binds dayjs.tz(x), never plain dayjs(x) - unlike
// moment.tz.setDefault(), which bound every moment(x) call. Naive strings (no
// offset) are assumed to already be Mexico City wall-clock time and must go
// through dayjs.tz() to pick up that default; anything that already carries
// real instant info (an ISO string with an offset, a Date, or a dayjs object)
// must be converted via dayjs.utc().tz() instead, since dayjs.tz(x) ignores
// an offset already present on its input.
// Same branching as momentLocalTimezone below, but without the trailing
// .utc(true) - the result stays a real timezone-anchored instant, so it's
// safe to re-serialize via .toISOString() (e.g. before sending a date back
// to the backend). momentLocalTimezone's .utc(true) tag re-labels the MX
// wall-clock digits as UTC for display/comparison parity, which corrupts
// the underlying instant if serialized directly.
export const toMexicoCityInstant = date => {
  if (date === undefined) {
    return dayjs.tz();
  }
  if (typeof date === 'string' && !HAS_TZ_OFFSET.test(date)) {
    return dayjs.tz(date);
  }
  return dayjs.utc(date).tz(MEXICO_CITY);
};

const momentLocalTimezone = date => toMexicoCityInstant(date).utc(true);

export default momentLocalTimezone;
